import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import KOTHING, { KInterface } from './keditor';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-kothing-html-editor',
  template: `<textarea #editor class="kothing-html-editor-input"></textarea>`,
  styleUrls: [
    './kothing-html-editor.component.scss'
  ]
})
export class KothingHtmlEditorComponent implements OnInit, AfterViewInit {

  @Input() type: 'full' | 'average' | 'basic' = 'full';
  @Input() height: string | number = 400;
  @Input() control?: FormControl;
  @Output() textChange = new EventEmitter<string>();

  @ViewChild('editor', {static: true}) wrapper: ElementRef;
  private keditor?: KInterface;
  private lastTimerId?: number;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const height: SimpleChange = changes.height;
    if (height && height.currentValue !== height.previousValue) {
      this.updateHeight(height.currentValue as number);
    }
  }

  updateHeight(height: number) {
    if (this.keditor) {
      this.keditor.setOptions({ height: height + "px" });
    }
  }

  getConfig() {
    const height = typeof this.height === "string" ? this.height : ((typeof this.height === 'number' && !isNaN(this.height)) ? this.height : 400);
    const result: any = {
      display: 'block',
      width: '100%',
      height: typeof height === "number" ? (height + 'px') : height,
      popupDisplay: 'full',
      charCounter: true,
      buttonList: []
    };
    if (this.type === 'full') {
      result.buttonList = [
        ['undo', 'redo'],
        ['font', 'fontSize', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike', 'removeFormat'],
        ['fontColor', 'hiliteColor'],
        ['outdent', 'indent'],
        ['align', 'horizontalRule', 'list', 'table'],
        ['link', 'image'],
        ['showBlocks', 'codeView', 'preview']
      ];
    } else if (this.type === 'average') {
      result.buttonList = [
        ['font', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike', 'removeFormat'],
        ['fontColor', 'hiliteColor'],
        ['outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
        ['link', 'image'],
        ['codeView', 'preview']
      ];
    } else if (this.type === 'basic') {
      result.buttonList = [
        ['undo', 'redo'],
        ['bold', 'underline', 'italic', 'strike']
      ];
    } else {
      console.warn(`Invalid html editor type: ${(this.type as any).toString()}`);
    }
    return result;
  }

  onContentChange(text: string) {
    this.textChange.emit(text);
    if (this.control) {
      if (!this.control.setValue) {
        console.warn("Control passed to kothing editor doesn't have a setValue method");
        console.log(this.control);
        return;
      }
      this.control.setValue(text);
    }
  }

  ngAfterViewInit() {
    this.keditor = KOTHING.create(
      this.wrapper.nativeElement,
      this.getConfig()
    );
    if (this.control && this.control.value) {
      setTimeout(() => this.keditor.setContents(this.control.value), 10);
    }
    this.keditor.onChange = this.onContentChange.bind(this);
  }

}
